if (!customElements.get('ff-newsletter-manage')) {
  customElements.define('ff-newsletter-manage', class FfImage extends HTMLElement {
  constructor(){
    super();
    this.checkBox = this.querySelector("#ff-checkbox-newsletter-manage");
    this.button = this.querySelector(".ff-button-general-primary");
    this.button.addEventListener("click",  () => {
      this.checkBox.checked ? this.changeState(true) : this.changeState(false);
    })
  }

  async changeState (state) {
    await fetch('/apps/tao-account/customers/newsletter', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({'aceptance': state, 'accessToken': localStorage.getItem("userAccesToken")} ),
      redirect: 'follow'
    })
    .then(result => result.json())
    .then(data => {
      window.location.replace("/account");
    })
    .catch(error => console.log('error', error));
  }
    
});
}
